import { IGetProductsResponse, IPostProductQuery, IPostProductUploadQuery, IPostProductUploadResponse, IProduct } from "../../../interfaces/api/IProducts";
import { IGetWithUuidQuery, IMessageResponse } from "../../../interfaces/api/IQueries";
import { api } from "../api";

/**
 * it adds the products endpoint to the api
 * 
 * @returns ProductsRepository
 */
const ProductsRepository = api.injectEndpoints({
    endpoints: (build) => ({
      getProducts: build.query<IGetProductsResponse, void>({
        query: () => ({url: "/products", method: "get"}),          
      }),
      postOneProduct: build.mutation<IMessageResponse, IPostProductQuery>(       
        {
        query: (data) => ({
          url: "/products",
          method: "post", 
          data,
        }),
      }),
      getOneProduct: build.query<IProduct|IMessageResponse, IGetWithUuidQuery>({
        query: (uuid) => ({url: `/products/${uuid}`, method: "get"}),
      }),
      postProductsUpload: build.mutation<IPostProductUploadResponse|IMessageResponse, IPostProductUploadQuery>({
        query: (data) => {
          const formData = new FormData();
          formData.append("file", data.file);
          return(
            {
              url: "/products/upload", 
              method: "post",
              headers: {
                  'Content-Type': 'multipart/form-data;',
              },
              data: formData,
              formData: true,
            }
          )
        },
      }),
    }),
} );

export const { 
  useGetProductsQuery,
  usePostOneProductMutation,
  useGetOneProductQuery,
  usePostProductsUploadMutation
} = ProductsRepository;